import { NotificationType } from '@/redux/slices/notificationSlice'
import ItemWrapper from './ItemWrapper'

export default function Unimplemented({ notification }: { notification: NotificationType }) {
  return <ItemWrapper notification={notification}>【Unimplemented】 {notification.verb}</ItemWrapper>
}
